import { Card, CardBody } from '@chakra-ui/react';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { type OptimizerError } from '../../_openapi/portfolio-optimizer';
import { PageContent } from '../../widgets/PageContent';
import { baseCol, textCol } from '../../widgets/Table/columnHelpers/colDef';
import { Table } from '../../widgets/Table/Table';

const columnHelper = createColumnHelper<OptimizerError>();
export const TradeErrors = ({ errors, isLoading }: { errors?: OptimizerError[]; isLoading: boolean }) => {
    const table = useReactTable({
        data: errors || [],
        columns: [
            columnHelper.accessor('pId', textCol({ id: 'pId' })),
            columnHelper.accessor('sId', textCol({ id: 'sId' })),
            columnHelper.accessor('allocationType', textCol({ id: 'allocationType' })),
            columnHelper.accessor('message', baseCol({ id: 'message' })),
        ],
        defaultColumn: {
            enableColumnFilter: false,
            enableSorting: false,
        },
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <PageContent isLoading={isLoading}>
            <Card size="sm">
                <CardBody>
                    <Table table={table} allowXOverflow />
                </CardBody>
            </Card>
        </PageContent>
    );
};
